import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "app/service/auth/auth.service";
import { MemberService } from "app/service/member/member.service";

@Component({
  selector: "modal-privacy",
  templateUrl: "./modal-privacy.component.html",
  styleUrls: ["../modal.component.scss", "./modal-privacy.component.scss"],
})
export class ModalPrivacyComponent implements OnInit {
  constructor(
    private memberService: MemberService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.isVisible) {
      document.body.style.overflow = "hidden";
    }
  }

  async handleSubmit() {
    if (!this.agree) {
      alert(
        "개인정보처리방침 변경에 대해서는 동의하지 않을 경우 홈페이지 이용이 불가합니다."
      );
    } else {
      await this.memberService.setPolicy({
        privacyPolicy: true,
      });
      this.authService.setPolicyStep("end");
      this.modal.showPrivacy = false;

      if (!this.modal.showThirdParty) {
        document.body.style.overflow = "";
      }
    }
  }

  @Input()
  get modal() {
    return this._modal;
  }
  set modal(data) {
    this._modal = data;
  }
  private _modal = {
    showPrivacy: false,
    showThirdParty: false,
  };

  get isVisible() {
    return this.modal.showPrivacy;
  }

  agree: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/modal/privacy/modal-privacy.component.ts